export const STUDENTS_LIMIT = 20;
